import {Injectable, signal} from '@angular/core';
import {Organization} from "../../../models/organization";
import {EntityInfo} from "../../../models/custom-models/entity-info";
import {FenceBackend} from "../models/geo-fence";

@Injectable({
    providedIn: 'root'
})
export class GeoFenceStoreService {
    private _isActive = signal(false);
    readonly isActive = this._isActive.asReadonly();

    private _geoFenceActiveOrg = signal<Organization[]>([]);
    readonly geoFenceActiveOrg = this._geoFenceActiveOrg.asReadonly();

    private _selectedOrg = signal<EntityInfo | null>(null);
    readonly selectedOrg = this._selectedOrg.asReadonly();

    private _fences = signal<FenceBackend[]>([]);
    readonly fences = this._fences.asReadonly();

    setFences(fences: FenceBackend[]): void {
        this._fences.set(fences);
    }

    setSelectedOrg(organization: EntityInfo | null): void {
        this._selectedOrg.set(organization);
        this.setFences([]); // Clear fences when org changes
    }

    setGeoFencingActiveOrg(organizations: Organization[]): void {
        this._geoFenceActiveOrg.set(organizations);
    }

    setGeoFencingActiveState(active: boolean): void {
        this._isActive.set(active);
    }
}
